import api from '@/shared/api/token'

const ENDPOINT = '/performance'

class PerformanceService {

  /*
   * GET /api/performance
   *
   * There is no id in the path: the server derives the client from the JWT (plus the
   * UserScope header the token interceptor adds when an agent is impersonating).
   *
   * doNotInterceptStatuses: [ 401 ]
   * ------------------------------------------------------------------------------
   * The global error interceptor logs the user OUT on 401. On this endpoint a 401 does
   * not mean "your session died", it means "you are an agent asking for a client that is
   * not yours" — the scope guard this endpoint enforces from day one. Logging the agent
   * out for that would be both wrong and baffling, so the 401 is handled locally and
   * rendered as a "not authorised" state instead.
   *
   * This is precise, not a blanket opt-out: authCheck rejects a bad or expired token with
   * INVALID_TOKEN / 403, which is NOT bypassed here and still logs the user out normally.
   */

  fetch() {
    return api.get(ENDPOINT, {
      doNotInterceptStatuses: [ 401 ]
    }).then((response) => {
      return response.data.data
    })
  }
}

export default new PerformanceService()
